<template>
    <div class="EmployeeCaseloadEditor">
        <!--DISPLAY TABLE-->
        <b-container fluid>
            <b-row style="overflow-x:auto;">
                <b-col cols="11">
                    <vuetable :fields="TableFields"
                              :data="TableData"
                              pagination-path=""
                              :api-mode="false"
                              class="vue-datatable"
                              :row-class="onRowClass">

                        <template slot="EmployeeName" scope="props">
                            <div class="EmployeeName">
                                <span :class="{'underline pointer': EditMode}" @click="ShowEditView(props.rowData)"><span v-html="props.rowData.Employee.Person.FullName"></span> <font-awesome-icon :icon="['fa', 'edit']" v-if="EditMode" /></span>
                            </div>
                        </template>
                    </vuetable>
                </b-col>
                <b-col cols="1">
                    <div v-if="EditMode" class="vert-icons">
                        <b-row>
                            <font-awesome-icon :icon="['fa', 'plus']" v-on:click="ShowAddView()" class="pointer olive-green-text" />
                        </b-row>
                    </div>
                </b-col>
            </b-row>
        </b-container>

        <!--ADD TEAM MEMBER MODAL-->
        <b-modal ref="modal-add" :title="AddMembershipTitle" hide-footer>
            <b-container v-if="EditMode">
                <b-form @submit="AddTeamMember">
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label>Employee:</label>
                                <v-select :options="EmployeeOptions" label="text" :reduce="option => option.value" v-model="TargetMembership.EmployeeID"></v-select>
                            </div>

                        </b-col>
                        <b-col>
                            <div class="form-group">
                                <label>Start Date:</label>
                                <flat-pickr v-model="TargetMembership.StartDate" class="form-control" required :config="DateConfig"></flat-pickr>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="CancelAdd()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="submit">
                                ADD
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>

        <!--EDIT TEAM MEMBER MODAL-->
        <b-modal ref="modal-edit" :title="EditMembershipTitle" hide-footer>
            <b-container v-if="TargetMembership.Employee">
                <b-form @submit="EditTeamMember">
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label>Start Date:</label>
                                <flat-pickr v-model="TargetMembership.StartDate" class="form-control" required :config="DateConfig"></flat-pickr>
                            </div>
                            <div class="form-group">
                                <label>End Date:</label>
                                <flat-pickr v-model="TargetMembership.EndDate" class="form-control" :config="DateConfig"></flat-pickr>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="CancelEdit()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="submit">
                                UPDATE
                            </b-button>
                            <b-button size="md" variant="danger" @click="DeleteTeamMember()" type="button">
                                DELETE
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
    </div>

</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faTrashAlt);
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import vSelect from 'vue-select'
    import 'vue-select/dist/vue-select.css';

    import Vuetable from 'vuetable-2/src/components/Vuetable';
    import { EventBus } from '../../../../services/event-bus.js';

    export default {
        props: [
            "EditMode",//bool
            "TeamRole",//string
            "ChartId",//string
            "TableData"
        ],
        data: function () {
            return {
                selected: [],
                TargetMembership: {},
                AddMEmbershipTitle: "",
                EditMembershipTitle: "",
                EmployeeOptions: [],
                MembershipSchema: {
                    Id: "",
                    StartDate: "",
                    EndDate: "",
                    Role: "",
                    EmployeeID: "",
                    ClientSubProgramMembershipID: ""
                },
                DateConfig: {
                    dateFormat: 'Y-m-d',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/Y',
                    required: false
                },
                TableFields: [
                    {
                        name: '__slot:EmployeeName',
                        title: 'NAME',
                        width: "33%"
                    },
                    {
                        name: 'StartDate',
                        title: 'STARTED',
                        callback: 'formatDate|MM/DD/YY',
                        width: "33%"
                    },
                    {
                        name: 'EndDate',
                        title: 'ENDED',
                        callback: 'formatDate|MM/DD/YY|N/A',
                        width: "33%"
                    }
                ]

            };
        },
        methods: {
            onRowClass(dataItem, index) {
                return (dataItem.EndDate == null) ? 'current-record' : '';
            },
            GetAvailableEmployees() {
                this.$MasterAPI.ExecuteRequest("GET", "Wraparound/Teams/EmployeeCaseloads/GetAvailableEmployeesForClient", { Id: this.ChartId, Role: this.TeamRole }, this.GetAvailableEmployeesSuccess, () => { }, false);
            },
            GetAvailableEmployeesSuccess(response) {
                this.EmployeeOptions = response.data.data;
            },
            ShowEditView(membership) {
                if (this.EditMode) {
                    this.TargetMembership = JSON.parse(JSON.stringify(membership));
                    this.EditMembershipTitle = "Editing " + membership.Employee.Person.FullName + "(" + this.EmployeeRole + ")";
                    this.$refs["modal-edit"].show();
                }
            },
            ShowAddView() {
                this.GetAvailableEmployees();
                this.TargetMembership = JSON.parse(JSON.stringify(this.MembershipSchema));
                this.TargetMembership.ClientSubProgramMembershipID = this.ChartId;
                this.TargetMembership.Role = this.TeamRole;
                this.AddMembershipTitle = "Add New " + this.TeamRole;
                this.$refs["modal-add"].show();
            },
            AddTeamMember(e) {
                e.preventDefault();
                //get person data here
                this.$MasterAPI.ExecuteRequest("POST", "Wraparound/Teams/EmployeeCaseloads/AddEmployeeToClient", this.TargetMembership, this.AddTeamMemberSuccess, () => { }, true);
            },
            AddTeamMemberSuccess(response) {
                this.$GlobalUpdate.ExecuteGlobalUpdate(this.ChartId);
                this.$refs["modal-add"].hide();
            },
            EditTeamMember(e) {
                e.preventDefault();
                //get person data here
                this.$MasterAPI.ExecuteRequest("POST", "Wraparound/Teams/EmployeeCaseloads/UpdateEmployeeCaseload", this.TargetMembership, this.EditTeamMemberSuccess, () => { }, true);
            },
            EditTeamMemberSuccess(response) {
                this.$GlobalUpdate.ExecuteGlobalUpdate(this.ChartId);
                this.$refs["modal-edit"].hide();
            },
            DeleteTeamMember() {
                this.$MasterAPI.ExecuteRequest("POST", "Wraparound/Teams/EmployeeCaseloads/DeleteEmployeeFromClient", { Id: this.TargetMembership.Id }, this.DeleteTeamMemberSuccess, () => { }, true);
            },
            DeleteTeamMemberSuccess(response) {
                this.$GlobalUpdate.ExecuteGlobalUpdate(this.ChartId);
                this.$refs["modal-edit"].hide();
            },
            CancelAdd() {
                this.selected = {};
                this.$refs['modal-add'].hide();
            },
            CancelEdit() {
                this.selected = {};
                this.$refs['modal-edit'].hide();
            },
            formatDate(value, fmt = 'D MMM YYYY') {
                return (value == null || value == '')
                    ? ''
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
        },
        components: {
            flatPickr,
            Vuetable,
            vSelect
        },
        computed: {
        },
        mounted() {
        },

    }
</script>

<style scoped>
    .vert-icons div {
        margin-top: 10px;
    }

    /deep/ tbody tr.current-record {
        font-weight: bold;
    }

    table {
        table-layout: auto;
    }

    .vue-datatable {
        width: 100%;
        display: inline-table;
        overflow-x: auto;
    }
</style>